const SOLR_URLS = {
  development: 'https://development.messe-stuttgart.de/solr',
  staging: 'https://staging.messe-stuttgart.de/solr',
  production: 'https://www.messe-stuttgart.de/solr',
};

const LMS_URLS = {
  development: 'https://lms-20-func-mkdb3-ebms-dev.azurewebsites.net',
  staging: 'https://lms-20-func-mkdb3-ebms-stg.azurewebsites.net',
  production: 'https://lms-20-func-mkdb3-ebms-prod.azurewebsites.net',
};

export const SOLR_VERSION = 'v1.0';

const environment = process.env.NODE_ENV || 'production';

// Select the correct URL based on the environment
export const SOLR_URL = SOLR_URLS[environment] || SOLR_URLS.production;
export const LMS_URL = LMS_URLS[environment] || LMS_URLS.production;
